module.exports = __webpack_public_path__ + "media/src/images/arrow_down_gy-bb48bfb9c7dc3ba6db56261fb41fda50.png";